import theme from '@/common/styles/mui-theme';

const newPasswordStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    m: 'auto',
    width: '100%',
    minHeight: '100%',
  },
  formWrapper: {
    margin: 'auto',
    px: theme.spacing(5),
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '500px',
      px: 0,
    },
  },
  successIcon: {
    display: 'block',
    margin: `0 auto ${theme.spacing(8)}`,
  },
};

export default newPasswordStyles;
